<template>
    <popup
      :button-style="buttonStyle"
      :heading="buttonText"
      :button-text="rowData ? '' : buttonText"
      center-button
      :disable-button="!isManager('finance|management')"
      :button-icon="rowData ? 'fa fa-edit' : buttonIcon"
      @save="onSave"
      @close="onClose">

      <el-form v-if="showRange" label-position="top">

          <el-row :gutter="12">

              <el-col :sm="24" :md="24":lg="18" align="center">
                <el-form-item label="Tenor Range (months)">
                  <el-slider
                     v-model="months"
                     range
                     show-stops
                     :step="6"
                     :min="0"
                     :max="maxMonths"
                     :marks="marks"
                      @change="updateMonths"
                      :disabled="disabled">
                   </el-slider>
                 </el-form-item>
              </el-col>

              <el-col :sm="24" :md="24" :lg="6" align="center">
                <el-form-item :label="plural('Year', years)">
                  <timeline :months="months" :max-months="maxMonths" :periods="periods" />
                </el-form-item>
              </el-col>

          </el-row>

      </el-form>

      <component :is="comp" :row-data="row" />

    </popup>

</template>



<script>

import SiteMixins from '@/mixins/SiteMixins'

import SharerRateDetails from './SharerRateDetails'
import TenancyRateDetails from './TenancyRateDetails'
import UtilityRateDetails from './UtilityRateDetails'

import Timeline from './Timeline'

export default {

  mixins: [SiteMixins],

  components: {
    Timeline
  },

  props: {

    view: {
      type: String,
      default: 'sharer'
    },

    rowData: {
      type: Object,
      default: null
    },

    showRange: {
      type: Boolean,
      default: true
    },

    tableRef: {
      type: String,
      default: this.view + 'ratesttable'
    }

  },

  methods: {

    init () {

      if (this.row && (this.row.fromMonth || this.row.toMonth)) {
        this.months = []
        this.months.push(this.row.fromMonth)
        this.months.push(this.row.toMonth)
      }

      switch (this.view) {
        case 'sharer':
              this.buttonText = 'Sharer'
              this.buttonIcon = 'fa fa-users'
              this.buttonStyle = 'warning'
              this.rateGroupPrefix = 80000
              this.comp = SharerRateDetails
              break

        case 'tenancy':
              this.buttonText = 'Tenancy'
              this.buttonIcon = 'fa fa-home'
              this.buttonStyle = 'success'
              this.rateGroupPrefix = 30000
              this.comp = TenancyRateDetails
              break

        case 'utility':
              this.buttonText = 'Utility'
              this.buttonIcon = 'fa fa-plug'
              this.buttonStyle = 'primary'
              this.rateGroupPrefix = 50000
              this.comp = UtilityRateDetails
              break

      }

      if (!this.row) {
        this.row = this.getTableStruct('rates')
        this.row.status = 'Active'
        this.row.groupId = this.rateGroupPrefix
        this.row.type = this.buttonText
      }


    },

    updateMonths(months) {

      if (this.isArray(months)) {

          this.months = months
          this.row.fromMonth = months[0]
          this.row.toMonth = months[1]
        }

    },
/*
    onEdit () {
      this.disabled !== this.disabled
    },
*/
    onSave () {
      console.log('row', this.row)
      this.saveForm(this, '/rates', this.row.id, this.row, this.buttonText, null, null, true, this.tableRef)
    },

    onClose () {
//      this.$message('Closing...')
    }

  },

  computed: {

    years: function () {
      return this.formatNumber((this.months[1] - this.months[0]) / 12, 1)
    }

  },



  data () {
    return {
      row: this.rowData,
      disabled: this.rowData ? true : false,
      data: [],

      comp: null,
      buttonText: null,
      buttonIcon: null,
      buttonStyle: null,
      heading: null,
      rateGroupPrefix: null,

      months: [0, 36],
      maxMonths: 300,
      periods: 3,

      marks: {
        24: '2 yrs',
        72: '6 yrs',
        120: '10 yrs',
        168: '14 yrs',
        216: '18 yrs',
        264: '22 yrs'
      }

    }
  },

  created () {
    this.init()
  }

}
</script>



// WEBPACK FOOTER //
// RatesAction.vue?52ab0721